/**
 * Esquema local — espelha as tabelas `valida_*` do TMobi para que o mesmo
 * servidor e o mesmo protocolo de sync continuem valendo sem tocar no backend.
 *
 * Regra da casa: migração só adiciona. Nunca renomeie nem remova coluna que já
 * possa ter validação de portaria dentro.
 */

export const VERSAO_ESQUEMA = 4;

export const MIGRACOES: string[][] = [
  // v1 — estado inicial
  [
    `create table if not exists evento (
       id integer primary key,
       nome text not null,
       data text,
       local text,
       cidade text
     )`,
    `create table if not exists lote (
       id integer primary key autoincrement,
       eventoId integer not null,
       loteStr text not null unique,
       setor text,
       setorId integer,
       consumacao text not null default '0'
     )`,
    `create index if not exists idx_lote_evento on lote (eventoId)`,
    `create table if not exists setor (
       id integer primary key autoincrement,
       remoteId integer not null unique,
       eventoId integer not null,
       nome text,
       habilitado integer not null default 1
     )`,
    `create index if not exists idx_setor_evento on setor (eventoId)`,
    `create table if not exists ingresso_online (
       id integer primary key autoincrement,
       eventoId integer not null,
       codbar text not null unique,
       nome text,
       email text,
       cpf text,
       pedidoId text,
       status text,
       setor text,
       setorId integer,
       numero text
     )`,
    `create index if not exists idx_online_evento on ingresso_online (eventoId)`,
    `create index if not exists idx_online_nome on ingresso_online (nome)`,
    `create index if not exists idx_online_email on ingresso_online (email)`,
    `create index if not exists idx_online_cpf on ingresso_online (cpf)`,
    `create index if not exists idx_online_pedido on ingresso_online (pedidoId)`,
    `create table if not exists ingresso_cancelado (
       id integer primary key autoincrement,
       eventoId integer not null,
       codbar text not null,
       dataCancelamento text,
       motivoCancelamento text,
       usuario text,
       unique (eventoId, codbar)
     )`,
    `create table if not exists validado (
       id integer primary key autoincrement,
       eventoId integer not null,
       codbar text not null unique,
       dataHora text not null,
       setorId text,
       consumacao text not null default '0',
       enviado integer not null default 0
     )`,
    `create index if not exists idx_validado_pendente on validado (enviado)`,
    `create table if not exists sync_estado (
       eventoId integer primary key,
       ultimaAtualizacao text not null default '2000-01-01',
       ultimaSincronizacao text
     )`,
  ],

  // v2 — separar o que foi validado NESTE aparelho do que desceu do servidor,
  // para o operador ver quanta gente ele mesmo passou.
  [
    'alter table validado add column local integer not null default 0',
    // Pendente de envio só pode ter nascido aqui: recupera o histórico existente.
    'update validado set local = 1 where enviado = 0',
    'create index if not exists idx_validado_local on validado (eventoId, local)',
  ],

  // v3 — quem pode liberar operação restrita quando não há rede na portaria.
  // Guarda o RESUMO da senha, nunca a senha: o banco do aparelho é legível com
  // root, e aparelho de portaria se perde.
  [
    `create table if not exists usuario_autorizado (
       remoteId integer primary key,
       nome text,
       nivel integer not null default 0,
       senhaHash text not null,
       atualizadoEm text
     )`,
  ],

  // v4 — a arte do evento no cartão da lista, para o operador reconhecer qual
  // é antes de ler o nome. Guarda o endereço, não a imagem: ela mora no site
  // da ticketeira e é enfeite — sem rede o cartão fica como sempre foi.
  ['alter table evento add column banner text'],
];
